import React from 'react';
import styled from 'styled-components';
import { TextAlignment } from '../../enum/EnumRepository';
import { StyledInputComponent } from '../../dto/StyleCompRepository';
import { useStandardAlertStore } from '../../store/portal/alertStore';
import HeadlessInput from '../headless/input/HeadlessInput';

interface MoleculeInputDivForModalProps {
  value: string | number;
  placeholder: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  inputStyle: StyledInputComponent;
  alignment?: TextAlignment;
  minLimit?: number;
  maxLimit?: number;
  maxLength?: number;
}

const MoleculeInputDivForModal: React.FC<MoleculeInputDivForModalProps> = ({
  value,
  placeholder,
  handleChange,
  inputStyle,
  alignment,
  minLimit,
  maxLimit,
  maxLength
}) => {
  const { setTextLengthExceededAlert } = useStandardAlertStore();
  const valueStr = value == null ? '' : String(value);

  const handleChangeWithLimit = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (maxLength && e.target.value.length > maxLength) {
      setTextLengthExceededAlert(maxLength);
      return;
    }
    handleChange(e);
  };

  return (
    <HeadlessInputWrapper>
      {maxLength && (
        <LimitDiv>
          {valueStr.length} / {maxLength}
        </LimitDiv>
      )}
      <HeadlessInput
        type={'text'}
        value={valueStr}
        handleChange={maxLength ? handleChangeWithLimit : handleChange}
        placeholder={placeholder}
        StyledInput={inputStyle}
        $alignment={alignment || TextAlignment.CENTER}
        minLimit={minLimit}
        maxLimit={maxLimit}
      />
    </HeadlessInputWrapper>
  );
};

const HeadlessInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const LimitDiv = styled.div`
  position: absolute;
  top: -8px;
  right: 0;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Body_04};
  user-select: none;
  z-index: 2;
`;

export default MoleculeInputDivForModal;
